export default {
	params: [],
	validate: (value) => {
		let regex = new RegExp(/0[1-9]|1[0-2]/, 'i');
		let match = regex.exec(value);

		return match.length > 0;
	},
	message: 'Invalid month'
};
